import { render, staticRenderFns } from "./AlertsView.vue?vue&type=template&id=4b42266e"
import script from "./AlertsView.vue?vue&type=script&lang=js"
export * from "./AlertsView.vue?vue&type=script&lang=js"
import style0 from "./AlertsView.vue?vue&type=style&index=0&id=4b42266e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports